import * as Helper from "./../../_Helper";
const controller = "/terminals/mobile/";

function getUrl(uid) {
  return `${controller}${uid?.toString()}/settings`;
}

function getDarkModeUrl(uid, isDark) {
  return `${controller}${uid?.toString()}/setdarkmode/${isDark}`;
}

function getRestartOrShutdownUrl(uid, operation) {
  return `${controller}${uid?.toString()}/operation/${operation}`;
}

function getLogUrl(uid) {
  return `${controller}${uid?.toString()}/log`;
}

export function getData(http, uid) {
  return http.get(getUrl(uid), Helper.getAuthConfig(uid));
}

export function setDarkMode(http, uid, isDark) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getDarkModeUrl(uid, isDark), null, Helper.getAuthConfig(uid));
}

export function runRestartOrShutdown(http, uid, operation) {
  //url, body, headers - tady je body pro post null protoze je to v url
  return http.post(getRestartOrShutdownUrl(uid, operation), null, Helper.getAuthConfig(uid));
}

export function addLog(http, uid, data) {
  //url, body, headers
  const body = { data: data };
  return http.post(getLogUrl(uid), body, Helper.getAuthConfig(uid));
}
